export default __webpack_public_path__ + "static/media/11.fe86769e.jpg";